
import React, { useEffect } from 'react';
import LiveSessionParticipantsView from '../LiveSessionParticipantsView';

interface LiveSessionParticipantsContainerProps {
  isMicActive: boolean;
  isVideoActive: boolean;
  isScreenSharing?: boolean;
  screenStream?: MediaStream | null;
  sessionId: string;
  userId: string;
  displayName: string;
  onMicLevelChange?: (level: number) => void;
}

const LiveSessionParticipantsContainer: React.FC<LiveSessionParticipantsContainerProps> = ({
  isMicActive,
  isVideoActive,
  isScreenSharing = false,
  screenStream = null,
  sessionId,
  userId,
  displayName,
  onMicLevelChange
}) => {
  // Mock participants data - adapted for better layout
  const mockParticipants = [
    {
      name: "You (Jamie Collins)",
      role: "Vocalist",
      isLocal: true,
      avatarUrl: "https://i.pravatar.cc/150?img=68",
      isScreenSharing: isScreenSharing
    },
    {
      name: "Alex Turner",
      role: "Producer",
      avatarUrl: "https://i.pravatar.cc/150?img=32",
      isMuted: false,
      isVideoOff: false,
      isScreenSharing: false
    },
    {
      name: "Sam Wilson",
      role: "Guitarist",
      avatarUrl: "https://i.pravatar.cc/150?img=53",
      isMuted: false,
      isVideoOff: false,
      isScreenSharing: false
    },
    {
      name: "Taylor Swift",
      role: "Engineer",
      avatarUrl: "https://i.pravatar.cc/150?img=45",
      isMuted: true,
      isVideoOff: false,
      isScreenSharing: false
    }
  ];

  // Force video container to update when video state changes
  useEffect(() => {
    console.log("Video active state changed in participants container:", isVideoActive);
  }, [isVideoActive]);

  return (
    <div className="h-full w-full flex overflow-auto bg-gradient-to-b from-black to-gray-900">
      <LiveSessionParticipantsView 
        participants={mockParticipants}
        isMicActive={isMicActive}
        isVideoActive={isVideoActive}
        isScreenSharing={isScreenSharing}
        screenStream={screenStream}
        sessionId={sessionId}
        userId={userId}
        displayName={displayName}
        onMicLevelChange={onMicLevelChange}
      />
    </div>
  );
};

export default LiveSessionParticipantsContainer;
